var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPolicyBenefitIconUpdated3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 60,
    viewBox: "0 0 84 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 60,
    rx: 29.4545,
    fill: "#D8ECED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.8062 31.9761L36.569 33.3891C36.3286 33.5854 35.4062 33.8699 34.9549 33.3008C34.425 32.7268 34.5624 32.1086 35.0039 31.7504M35.0039 31.7504L39.6943 28.7822C41.5047 30.0038 43.055 29.6751 44.051 29.1649C44.679 28.846 44.6986 27.9579 44.0951 27.5949L40.1407 25.235C37.9133 23.9643 35.578 25.8041 35.578 25.8041L33.2622 24.8082L30.5785 29.3857L35.0039 31.7504Z",
    stroke: "#0D4248",
    strokeWidth: 0.791044,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6414 26.1329L42.6227 25.3724C43.3488 24.8082 44.2172 24.3912 45.3505 24.818L48.6132 26.0348L50.7474 24.8671L53.5537 29.0374L50.3156 31.2206",
    stroke: "#0D4248",
    strokeWidth: 0.791044,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7081 30.6883L50.7426 31.5847C51.1399 31.9289 51.1828 32.5301 50.8386 32.9273L50.7358 33.046C50.3915 33.4432 49.7904 33.4862 49.3932 33.142L48.3587 32.2456C47.9614 31.9013 47.9184 31.3002 48.2627 30.9029L48.3655 30.7843C48.7097 30.387 49.3109 30.344 49.7081 30.6883Z",
    stroke: "#0D4248",
    strokeWidth: 0.791044,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3949 33.1506L47.9526 31.9008C47.5559 31.557 46.9538 31.6001 46.61 31.9968L46.5072 32.1154C46.1634 32.5122 46.2064 33.1143 46.6032 33.4581L48.0455 34.7079C48.4422 35.0517 49.0443 35.0086 49.3881 34.6119L49.4909 34.4932C49.8347 34.0965 49.7917 33.4944 49.3949 33.1506Z",
    stroke: "#0D4248",
    strokeWidth: 0.791044,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4529 33.3244L48.0396 34.6998C48.4368 35.0441 48.4797 35.6452 48.1354 36.0424L48.0325 36.1611C47.6882 36.5583 47.0871 36.6012 46.6899 36.2569L45.1032 34.8814C44.706 34.5371 44.6631 33.936 45.0074 33.5388L45.1102 33.4202C45.4545 33.023 46.0557 32.9801 46.4529 33.3244Z",
    stroke: "#0D4248",
    strokeWidth: 0.791044,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0011 34.7962L45.7612 35.4548C46.1584 35.7991 46.2014 36.4002 45.8572 36.7974L45.7543 36.9161C45.4101 37.3134 44.809 37.3563 44.4117 37.0121L43.6516 36.3534C43.2543 36.0092 43.2114 35.4081 43.5556 35.0108L43.6584 34.8922C44.0027 34.4949 44.6038 34.4519 45.0011 34.7962Z",
    stroke: "#0D4248",
    strokeWidth: 0.791044,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4453 33.3886L37.9382 35.1205C37.6978 35.3167 37.3937 35.3854 37.114 35.3363C36.8785 35.2971 36.6577 35.1695 36.4958 34.9684C36.1377 34.5268 36.1328 33.7467 36.5743 33.3886L38.8115 31.9756",
    stroke: "#0D4248",
    strokeWidth: 0.791044,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7246 34.7536L39.7327 36.299C39.5168 36.4609 39.2519 36.5198 39.0017 36.4757C38.7956 36.4413 38.5994 36.3334 38.4522 36.1617C38.1333 35.7888 38.1038 34.9891 38.4865 34.6898L40.449 33.3896",
    stroke: "#0D4248",
    strokeWidth: 0.791044,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7256 34.7534L40.9112 35.3863C40.0477 36.0536 40.656 36.8778 40.656 36.8778C40.656 36.8778 41.2497 37.7707 42.4566 37.0005L43.5654 36.2645",
    stroke: "#0D4248",
    strokeWidth: 0.791044,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7479 24.8671L50.2671 24.1901C50.061 23.9006 50.1445 23.4934 50.4486 23.3069L51.7537 22.5121C52.0382 22.3404 52.4062 22.4238 52.5877 22.6986L56.2478 28.2426C56.4391 28.532 56.3557 28.9196 56.0613 29.1012L54.8053 29.896C54.5159 30.0824 54.1283 29.9892 53.9517 29.6948L53.5494 29.0325",
    stroke: "#0D4248",
    strokeWidth: 0.791044,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2574 24.8085L33.7382 24.1315C33.9443 23.842 33.8609 23.4348 33.5567 23.2483L32.2517 22.4535C31.9671 22.2818 31.5991 22.3652 31.4176 22.64L27.7527 28.6893C27.5613 28.9788 27.6447 29.3664 27.9391 29.5479L29.1951 30.3427C29.4846 30.5292 29.8721 30.4359 30.0488 30.1416L30.4511 29.4792",
    stroke: "#0D4248",
    strokeWidth: 0.791044,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicyBenefitIconUpdated3);
export default __webpack_public_path__ + "static/media/policy-benefit-icon_updated_3.861c6e060449e2a6621c0b72c0f75f2f.svg";
export { ForwardRef as ReactComponent };